import React, { createContext, useContext } from 'react';
import isUndefined from 'lodash/isUndefined';

const EventContext = createContext();

export const EventProvider = ({ event, ...rest }) => {
  return (
    <EventContext.Provider value={{ legacyEvent: event, event }} {...rest} />
  );
};

export const useEvent = () => {
  const context = useContext(EventContext);

  if (isUndefined(context)) {
    throw new Error('useEvent must be used within a EventContext');
  }

  return context;
};

export default EventContext;
